import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

export default function SpringMattressPage() {
  const categoryName = "Spring Mattress";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Coil-on-Coil-1.png",
      name: "COIL ON COIL",
      link: "/patent-series-mattress/coil-on-coil/",
      price: 125099,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
      name: "TIARA COOL",
      link: "/patent-series-mattress/tiara-cool/",
      price: 78999,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Accolade.png",
      name: "ACCOLADE PT",
      link: "/patent-series-mattress/accolade-pt/",
      price: 36899,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Oslo-Plush12.png",
      name: "HEALTHSENSE ET",
      link: "/patent-series-mattress/healthsense-et/",
      price: 34799,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-comfort-PT.png",
      name: "POSTURE COMFORT",
      link: "/luxury-collection/posture-comfort/",
      price: 24199,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/portofino-Latex.png",
      name: "PORTOFINO LATEX",
      link: "/latex-mattress/portofino-latex/",
      price: 19399,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Portofino-PT.png",
      name: "PORTOFINO PT",
      link: "/conformatic-mattress/portofino-pt/",
      price: 15999,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Portofino.png",
      name: "PORTOFINO",
      link: "/serene-series/portofino/",
      price: 14599,
    },

    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/Viena-1000X676.png",
      name: "VIENNA ET",
      link: "/patent-series-mattress/vienna-et/",
      price: 32399,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-Therapy-PT-1.png",
      name: "POSTURE THERAPY",
      link: "/luxury-collection/posture-therapy/",
      price: 22499,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-2.png",
      name: "POSTURE CARE",
      link: "/luxury-collection/posture-care/",
      price: 21699,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton-Latex.png",
      name: "PRINCETON LATEX",
      link: "/latex-mattress/princeton-latex/",
      price: 18199,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton-PT.png",
      name: "PRINCETON PT",
      link: "/contour-series/princeton-pt/",
      price: 13299,
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton.png",
      name: "PRINCETON",
      link: "/serene-series/princeton/",
      price: 11899,
    },
  ];

  const categoryDescription =
    "Spring mattresses are a classic choice for discerning sleepers. Each mattress is constructed with a heavy gauge spring system with plush cushioning for excellent, firm support. Explore Eclipse’s wide range of premium spring mattresses across categories, with an array of benefits suited to your sleep style.";

  const sortedProducts = products.sort(function (a, b) {
    return b.price - a.price;
  });

  // console.log("sorted", sortedProducts);

  return (
    <div>
      <SEO
        title="Spring Mattress | Eclipse International"
        description="Explore Eclipse’s high coil count innerspring mattresses for ultimate support. Quality assured with 10 year warranty."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
